// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1QftB","options":"AnswerScale_options__3Q0NA","selected":"AnswerScale_selected__2-z3R"};